import { css } from '@emotion/react';
import { forwardRef } from 'react';
export function lineClampStyle(lines = 1) {
  return /*#__PURE__*/css(lines === 1 ? {
    // workaround when only one line is required
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  } : {
    // line-clamp is not standardized yet so we must use the webkit prefix.
    // See https://css-tricks.com/almanac/properties/l/line-clamp/#so-whats-the-catch
    display: '-webkit-box',
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  }, process.env.NODE_ENV === "production" ? "" : ";label:lineClampStyle;");
}
/**
 * Limit the number of lines a block of text can have.
 *
 * This is a replacement for `Truncate` from react-truncate.
 */
// eslint-disable-next-line @typescript-eslint/no-shadow
export const LineClamp = forwardRef(function LineClamp({
  lines = 1,
  ...props
}, ref) {
  return <div css={lineClampStyle(lines)} {...props} ref={ref} />;
});